import styled from 'styled-components';
export const StyledFrame = styled.section `
  position: relative;
  height: 100vh;
  width: 100vw;
  background: ${({ theme }) => theme.palette.background.default};
`;
